"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowActionFilesResponseSchema = exports.workflowActionFileItemSchema = void 0;
const zod_1 = require("zod");
const WorkflowActionType_1 = require("../../project/WorkflowActionType");
const selectedItemWithName_schema_1 = require("../selectedItemWithName.schema");
const workflowActionFile_schema_1 = require("../workflowActionFile.schema");
exports.workflowActionFileItemSchema = workflowActionFile_schema_1.workflowActionFileSchema
    .extend({
    workflowActionId: zod_1.z.string(),
    workflowActionType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(WorkflowActionType_1.WorkflowActionType),
})
    .strict();
exports.workflowActionFilesResponseSchema = zod_1.z
    .object({
    items: exports.workflowActionFileItemSchema.array(),
})
    .strict();
//# sourceMappingURL=workflowActionFilesResponse.schema.js.map